import { PAYMENT_TYPES } from '@vend/business-components'
import { FulfilmentType } from '../models/fulfilment'

export const convertFulfillmentType = (type: FulfilmentType | undefined) => {
  switch (type) {
    case FulfilmentType.DELIVERY:
      return 'DELIVERY'
    case FulfilmentType.PICKUP:
      return 'PICKUP'
    default:
      return undefined
  }
}

// Create the reverse lookup map once at module level for performance
const PAYMENT_TYPE_ID_TO_NAME_MAP = Object.entries(PAYMENT_TYPES).reduce(
  (map, [key, value]) => {
    map[value] = key
    return map
  },
  {} as Record<number, string>
)

/**
 * Maps a payment type ID to its corresponding standard enum name
 * @param typeId The numeric payment type ID
 * @returns The standard enum name (e.g., "CASH", "CREDIT_CARD", etc.)
 */
export const convertPaymentTypeIdToEnum = (typeId: number): string => {
  return PAYMENT_TYPE_ID_TO_NAME_MAP[typeId] || 'UNKNOWN'
}

const IMAGE_CDN_HOSTNAME = 'vendimageuploadcdn.global.ssl.fastly.net'
/**
 * filters the product image url to return only valid image urls from the CDN, otherwise returns undefined
 * @param {string | null | undefined} imageUrl - The URL value to evaluate.
 * @returns {string | undefined}
 */
export const getValidProductImageUrl = (
  imageUrl: string | null | undefined
): string | undefined => {
  if (typeof imageUrl !== 'string' || imageUrl.length === 0) {
    return undefined
  }

  let url: URL
  try {
    url = new URL(imageUrl)
  } catch (e) {
    return undefined
  }

  return url.hostname === IMAGE_CDN_HOSTNAME ? imageUrl : undefined
}
